import styled from "../../theme";
import Flex from "./flex";

/**
 * @deprecated Use native HTML elements with tailwind classes
 */
export const Grid = styled(Flex)`
  display: grid;
`;

Grid.displayName = "Grid";

export default Grid;
